(function($){
    $.fn.modalDialog = function(options){
    // eslint-disable-next-line no-unused-vars
        var settings = $.extend({ /*default Settings*/ }, options),
            $body = $('body'),
            $doc = $(document),
            open = 'modal-open',
            active = 'active';
    
        this.each(function(){
            var $this = $(this),
                modal = $this.attr('href'),
                $modal = $(modal),
                $modalStage = $modal.find('.zn-modal-stage'),
                $close = $modal.find('.zn-close-modal'),
                closeThis = function(){
                    $modal.removeClass(active);
                    $modal.fadeOut(200);
                    $body.removeClass(open);
                    $doc.off('click.modal').off('keydown.modal').off('focusin.modal');

                    if ($modal.hasClass('zn-modal-video')){
                        $('.zn-video-stage iframe').remove();
                    }

                    $this.focus();
                };

            $modalStage.attr('role', 'dialog').attr('aria-modal', 'true');

            $this.on('click', function(clickEvent){
                clickEvent.preventDefault();
                if(!$body.hasClass(open)){
                    if ($modal.hasClass('zn-modal-video') && $modal.attr('data-video-id').length > 0){
                        $('<iframe id="yt-video-player" type="text/html" src="https://www.youtube.com/embed/' + $modal.attr('data-video-id') + '?enablejsapi=1&rel=0&modestbranding=1" frameborder="0"></iframe>').appendTo($modal.find('.zn-video-stage'));
                    }

                    $body.addClass(open);
                    $modal.fadeIn(200, function(){
                        $modal.addClass(active);
                        $modalStage.attr('tabindex', '0').focus();

                        $doc.on('focusin.modal', function(e){
                            //var focusedItem = $(document.activeElement);
                            if ($body.hasClass(open) && !$.contains($modal.get(0), e.target)){
                                $modalStage.focus();
                            }
                        }).on('click.modal', function(e){
                            e.stopPropagation();
                            if(!$modal.find(e.target).length){
                                closeThis();
                            }
                        }).on('keydown.modal', function(e){
                            e.stopPropagation();
                            var keyCode = e.which;

                            if(keyCode === 27){
                                closeThis();
                            }
                        });
                    });
                }
            });

            if ($close.length){
                $close.addAccess();
                $close.on('click', function(){
                    closeThis();
                });
            }
        });
    };

    $(function(){
        var $modalLink = $('.zn-modal-link'),
            $modalDialog = $('.zn-modal');

        if ($modalLink.length && $modalDialog.length){
            $modalLink.modalDialog();
        }
    });
})($JQ);